import { Component, OnInit } from '@angular/core';
import { ClrIconModule } from "@clr/angular";
import { JsonPipe, NgIf } from "@angular/common";
import { OrderFormComponent } from "../order-form/order-form.component";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { Orders } from "../../../_shared/interfaces";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { AlertService, IAlertType, OrdersStoreService } from "../../../_shared/services";

import {environment as env} from "../../../../environments/environment";

@Component({
  selector: 'app-order-update',
  standalone: true,
  imports: [
    ClrIconModule,
    JsonPipe,
    NgIf,
    OrderFormComponent,
    RouterLink
  ],
  templateUrl: './order-update.component.html',
  styleUrl: './order-update.component.sass'
})
export class OrderUpdateComponent implements OnInit {
  projectId: string = '';
  jobId: number = 0;
  orderId: number = 0;
  orders: Orders[] = [];

  devMode: boolean;

  constructor(
    private ordss: OrdersStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '');
    this.orderId = parseInt(params.get('ordid') ?? '');
    this.loadOrder(this.projectId, this.orderId);
  }

  loadOrder(prid: string, ordid: number) {
    this.ordss.getOrders(prid, ordid, 0,'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Orderdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }

        this.orders = data.object;
        if (this.devMode) console.table(this.orders[0]);

      },
      complete: () => {},
      error: () => {
        return;
      }
    });
  }
}
